import { IOfferChatV2Schema } from '@cian/chats-api';
import { ETransportType } from '@cian/chats-api/lib/shared/geo/schema';

import { IOfferGeo } from '../../types/offer';

export const mapOfferGeoV2VersionToV1 = (geo: IOfferChatV2Schema['geo']): IOfferGeo => {
  if (!geo) {
    return {
      address: [],
      highways: [],
    };
  }

  const mapTransportType = (transportType?: ETransportType): ETransportType => transportType || ETransportType.Walk;

  return {
    address:
      geo.address?.map(({ id, shortName, locationTypeId, name }) => ({
        id: id || 0,
        shortName: shortName || '',
        locationTypeId: locationTypeId || null,
        name: name || '',
      })) || [],
    highways: geo.highways || [],
    undergrounds:
      geo.undergrounds?.map(({ isDefault, time, lineColor, name, transportType }) => ({
        isDefault: isDefault || false,
        time: time || 0,
        lineColor: lineColor || '',
        name: name || '',
        transportType: mapTransportType(transportType),
      })) || undefined,
  };
};
